import withSuspense from "../../../../hocs/withSuspense";
import { SettingsPageSkeleton, SettingsError } from "../../components";
import {
  EditPhoneNumberPage,
  EditPhoneNumberPageProps,
} from "./EditPhoneNumberPage";

export const EditPhoneNumberPageWithSuspense =
  withSuspense<EditPhoneNumberPageProps>(EditPhoneNumberPage, {
    FallbackComponent: SettingsError,
    loading: <SettingsPageSkeleton rows={1} testId="edit-phone" />,
  });
